import {Button, Divider, Typography} from 'antd';
import CardItem from './CardItem';
const {Text} = Typography;

const OrderSection = ({
  cartItems,
  productItems,
  shippingCharges,
  discountConfig,
  createCodOrder,
  sendPaymentLink,
  copyCheckoutLink,
  shopUrl,
  isSendInChatDisabled,
  isWhatsappCheckoutEnabled,
  currencySymbol,
  isDiscountOverLimit,
}) => {
  const totalCartValue = cartItems.reduce((acc, item) => {
    return acc + item.price * item.quantity;
  }, 0);
  let discountValue = discountConfig.value || 0;
  if (discountConfig.type === 'static') {
    discountValue = 0;
  }
  const grandTotal = totalCartValue + +shippingCharges - +discountValue;
  // An over-limit discount is rejected by the backend anyway; block it here so the
  // agent fixes it before promising the customer a price.
  const isOrderBlocked = isSendInChatDisabled || isDiscountOverLimit;

  return (
    <CardItem>
      <Text
        style={{
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: '16px',
          color: '#1F2D3D',
        }}
      >
        Order Summary
      </Text>
      <Divider style={{margin: '0px'}} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Total Cart Value
        </Text>
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          {currencySymbol}{totalCartValue}
        </Text>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Shipping Charges
        </Text>
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          {currencySymbol}{shippingCharges}
        </Text>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Discount
        </Text>
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          {currencySymbol}{discountValue}
        </Text>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Grand Total
        </Text>
        <Text
          style={{
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          {currencySymbol}{grandTotal}
        </Text>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Button
          disabled={isOrderBlocked}
          onClick={createCodOrder}
          style={{
            backgroundColor: 'none',
            border: '1px solid #369eff',
            color: isOrderBlocked ? '#999999' : '#369eff',
            width:
              shopUrl !== 'bombay-shaving.myshopify.com' &&
              shopUrl !== 'bsc-women.myshopify.com'
                ? '48%'
                : '100%',
            fontWeight: 600,
            cursor: isOrderBlocked ? 'not-allowed' : 'pointer',
          }}
        >
          Place COD Order
        </Button>
        {shopUrl !== 'bombay-shaving.myshopify.com' &&
          shopUrl !== 'bsc-women.myshopify.com' && (
            <Button
              disabled={isOrderBlocked || !isWhatsappCheckoutEnabled}
              onClick={sendPaymentLink}
              style={{
                backgroundColor: (isOrderBlocked || !isWhatsappCheckoutEnabled) ? '#E5E5E5' : '#369eff',
                color: (isOrderBlocked || !isWhatsappCheckoutEnabled) ? '#999999' : '#fff',
                width:
                  shopUrl !== 'bombay-shaving.myshopify.com' ? '48%' : '100%',
                cursor: (isOrderBlocked || !isWhatsappCheckoutEnabled) ? 'not-allowed' : 'pointer',
              }}
            >
              Send Payment Link
            </Button>
          )}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          marginTop: '10px',
        }}
      >
        <Button
          disabled={isDiscountOverLimit}
          onClick={copyCheckoutLink}
          style={{
            backgroundColor: isDiscountOverLimit ? '#E5E5E5' : '#28a745',
            color: isDiscountOverLimit ? '#999999' : '#fff',
            width: '100%',
            fontWeight: 600,
            cursor: isDiscountOverLimit ? 'not-allowed' : 'pointer',
          }}
        >
          Copy Checkout Link
        </Button>
      </div>
    </CardItem>
  );
};

export default OrderSection;
